import { render, staticRenderFns } from "./SignerFromDraft.vue?vue&type=template&id=79d90cd4&"
import script from "./SignerFromDraft.vue?vue&type=script&lang=js&"
export * from "./SignerFromDraft.vue?vue&type=script&lang=js&"
import style0 from "./SignerFromDraft.vue?vue&type=style&index=0&id=79d90cd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports